import axios from "axios";
import React, { useEffect, useState } from "react";
import { apiCall_domain } from "../api";
import ProductMainCard from "../global/ProductMainCard";
import Spinner from "../Spinner/Spinner";
import Header from "../header";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useHistory, useLocation } from "routerCompat";
export default function InstallmentsProducts(props) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const search = useLocation().search;
  let page = new URLSearchParams(search).get("page");
  const history = useHistory();

  const fetchData = (page) => {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .get(
        `${apiCall_domain}/customer/products?is_installment=1&page=${
          page || 1
        }`,
        { headers },
      )
      .then((res) => {
        setData(res.data.products);
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchData(page);
  }, []);
  return (
    <div className="instalments">
      {loading ? (
        <Spinner />
      ) : (
        <>
          <Header showSearchBar={true} title={"کالا های اقساطی"} />

          <div className="instalments-products">
            {data.data &&
              data.data.map((product) => (
                <ProductMainCard
                  data={product}
                  slug={product.slug}
                  deadline={product.deadline}
                  countDown={false}
                  featuresStat={true}
                  features={product.features}
                />
              ))}
          </div>
          <div className="instalmentsPagination">
            <Stack spacing={2}>
              <Pagination
                count={data.meta.last_page}
                page={data.meta.current_page}
                onChange={(e, value) => {
                  history.push(`?page=${value}`);
                  window.location.reload();
                }}
              />
            </Stack>
          </div>
        </>
      )}
    </div>
  );
}
